import Video from "./pages/Video";
import Teams from "./pages/Teams";
import Feeds from "./pages/Feeds";
import Orders from "./pages/Orders";
import Report from "./pages/Report";
import TeamMail from "./pages/TeamMail";
import DuaFeeds from "./pages/DuaFeeds";
import MailPage from "./pages/MailPage";
import RushData from "./pages/RushData";
import Category from "./pages/Category";
import Products from "./pages/Products";
import Schedule from "./pages/Schedule";
import RushNews from "./pages/RushNews";
import RushStaff from "./pages/RushStaff";
import AdminList from "./pages/AdminList";
// import Dashboard from "./pages/DashBoard";
import Insurance from "./pages/Insurance";
import ParentCamp from "./pages/ParentCamp";
import AllPlayers from "./pages/AllPlayers";
import RushParents from "./pages/RushParents";
import EpipathData from "./pages/EpipathData";
import TeamPlayers from "./pages/TeamPlayers";
import RushPlayers from "./pages/RushPlayers";
import SubCategory from "./pages/SubCategory";
import OrderDetail from "./pages/order-detail";
import Notification from "./pages/Notification";
import AdminProducts from "./pages/AdminProducts";
import RushPlayerForm from "./pages/RushPlayerForm";
import InsuranceClaims from "./pages/InsuranceClaims";
import MallPageDetails from "./pages/MallPageDetails";
import PrayerPageIcons from "./pages/PrayerPageIcons";
import RushPlayerDetail from "./pages/RushPlayerDetail";
import PrayerTimeBanners from "./pages/PrayerTimeBanners";
import PrayerPageBanners from "./pages/PrayerPageBanners";
import StudentFileUpload from "./pages/StudentFileUpload";
import TransactionHistory from "./pages/TransactionHistory";
import PlayerPaymentDetails from "./pages/PlayerPaymentDetails";
import Message from "./pages/Message";
import Links from "./pages/Links";
import Hadist from "./pages/Hadist";
import ParentList from "./pages/rushUser/ParentList";
import RushUserEvents from "./pages/rushUser/RushUserEvents";
import RushUserPlayerDetails from "./pages/rushUser/RushUserPlayerDetails";
import RushUserPaymentDetails from "./pages/rushUser/RushUserPaymentDetails";

import Profile from "./pages/membership/Profile";
import Membership from "./pages/membership/Membership";

export const routes = [
  {
    path: "/",
    permission: "shop",
    component: Products,
  },
  {
    path: "/products",
    permission: "shop",
    component: Products,
  },
  {
    path: "/orders",
    permission: "shop",
    component: Orders,
  },
  {
    path: "/orderDetail",
    permission: "shop",
    component: OrderDetail,
  },

  // {
  //   path: "/shopdashboard",
  //   permission: "shop",
  //   component: Dashboard,
  // },
  //rushAdmin
  {
    path: "/",
    permission: "rushAdmin",
    component: RushData,
  },
  {
    path: "/events",
    permission: "rushAdmin",
    component: RushData,
  },

  {
    path: "/parentEvents",
    permission: "rushAdmin",
    component: ParentCamp,
  },
  {
    path: "/sendmail",
    permission: "rushAdmin",
    component: MailPage,
  },
  {
    path: "/teams",
    permission: "rushAdmin",
    component: Teams,
  },
  {
    path: "/players",
    permission: "rushAdmin",
    component: RushPlayers,
  },
  {
    path: "/payForPlayers",
    permission: "rushAdmin",
    component: AllPlayers,
  },
  {
    path: "/teamplayers",
    permission: "rushAdmin",
    component: TeamPlayers,
  },
  {
    path: "/playerDetail",
    permission: "rushAdmin",
    component: RushPlayerDetail,
  },
  {
    path: "/playerPaymentDetail",
    permission: "rushAdmin",
    component: PlayerPaymentDetails,
  },
  {
    path: "/registrationForm",
    permission: "rushAdmin",
    component: RushPlayerForm,
  },
  {
    path: "/schedule",
    permission: "rushAdmin",
    component: Schedule,
  },

  // {
  //   path: "/news",
  //   permission: "rushAdmin",
  //   component: RushNews,
  // },
  // {
  //   path: "/message",
  //   permission: "rushAdmin",
  //   component: Message,
  // },
  // {
  //   path: "/links",
  //   permission: "rushAdmin",
  //   component: Links,
  // },
  {
    path: "/notification",
    permission: "rushAdmin",
    component: Notification,
  },
  {
    path: "/teamMail",
    permission: "rushAdmin",
    component: TeamMail,
  },
  {
    path: "/parents",
    permission: "rushAdmin",
    component: RushParents,
  },
  {
    path: "/staff",
    permission: "rushAdmin",
    component: RushStaff,
  },
  {
    path: "/transactionHistory",
    permission: "rushAdmin",
    component: TransactionHistory,
  },
  {
    path: "/report",
    permission: "rushAdmin",
    component: Report,
  },

  //RushUser Routs
  {
    path: "/",
    permission: "rushUser",
    component: ParentList,
  },
  {
    path: "/parentlist",
    permission: "rushUser",
    component: ParentList,
  },
  {
    path: "/rushUserPlayerDetail",
    permission: "rushUser",
    component: RushUserPlayerDetails,
  },
  {
    path: "/rushUserPaymentDetails",
    permission: "rushUser",
    component: RushUserPaymentDetails,
  },
  {
    path: "/events",
    permission: "rushUser",
    component: RushUserEvents,
  },
  //end
  //Admin routes

  {
    path: "/",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: AdminProducts,
  },
  {
    path: "/",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: AdminProducts,
  },
  // {
  //   path: "/Dashboard",
  //   permission: "admin",
  //   forApps: [],
  //   component: Dashboard,
  // },

  {
    path: "/mallProducts",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: AdminProducts,
  },
  {
    path: "/minimartProducts",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: AdminProducts,
  },
  {
    path: "/mallPageDetails",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: MallPageDetails,
  },
  {
    path: "/mallCategories",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: Category,
  },
  {
    path: "/minimartCategories",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: Category,
  },
  {
    path: "/mallSubCategories",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: SubCategory,
  },
  {
    path: "/minimartSubCategories",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: SubCategory,
  },
  {
    path: "/video",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: Video,
  },
  {
    path: "/prayerPageIcons",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: PrayerPageIcons,
  },
  {
    path: "/prayerPageBanners",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: PrayerPageBanners,
  },
  {
    path: "/prayerTimeBanners",
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "trandz",
      "chevy",
      "epson",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
    component: PrayerTimeBanners,
  },
  {
    path: "/studentFile",
    permission: "admin",
    forApps: ["uin"],
    component: StudentFileUpload,
  },
  {
    path: "/hadist",
    permission: "admin",
    forApps: ["istiqlal"],
    component: Hadist,
  },
  {
    path: "/epipath",
    permission: "admin",
    forApps: ["istiqlal"],
    component: EpipathData,
  },
  {
    path: "/duafeeds",
    permission: "admin",
    forApps: ["trandz"],
    component: DuaFeeds,
  },
  //Super admin routes
  {
    path: "/",
    permission: "superadmin",
    component: AdminList,
  },
  {
    path: "/adminList",
    permission: "superadmin",
    component: AdminList,
  },
  {
    path: "/feeds",
    permission: "superadmin",
    component: Feeds,
  },
  //jasklikadmin routes
  {
    path: "/insurance",
    permission: "jasklikadmin",
    component: Insurance,
  },
  {
    path: "/claims",
    permission: "jasklikadmin",
    component: InsuranceClaims,
  },
  {
    path: "/",
    permission: "membershipAdmin",
    component: Membership,
  },
  {
    path: "/memberships",
    permission: "membershipAdmin",
    component: Membership,
  },
  {
    path: "/profile",
    permission: "membershipAdmin",
    component: Profile,
  }
];
